<template>
  <div class="app">
     <div class="navBox">
       <ul class="ul">
         <li class="li" :class="{'li-activate': navIndex == index}" v-for="(item, index) in navList" :key="index" @click="handleNavClick(index)">
           <!-- 图片 -->
           <img :src='item.img' alt="">
           {{item.name}}
          <div :class="{'navBox-li-line': navIndex == index}"></div>
         </li>
       </ul>
     </div>
  </div>
</template>

<script>
  export default {
  data() {
    return {
      navList: [
        {
         name:'全部分类',
         img:'img/index/categories.png'
       },
        {
         name:'非洲鼓',
         img:'img/index/categories.png'
       },
        {
         name:'爵士鼓',
         img:'img/index/categories.png'
       },
        {
         name:'品才',
         img:'img/index/categories.png'
       },
        {
         name:'口才',
         img:'img/index/categories.png'
       },
        {
         name:'爵士鼓',
         img:'img/index/categories.png'
       }
      ],
      navIndex: 0
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleNavClick (index) {
      this.navIndex = index;
    }
  },
}
</script>

<style lang='less' scoped>
.app {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
}
.navBox {
  width: 100%;
  height: 3.5rem;
  background: #ffffff;
  .ul {
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow: auto;
    white-space: nowrap;
    position: relative;
    padding: 0rem 0.8rem;
    box-sizing: border-box;
    .li {
      width: auto;
      height: 100%;
      line-height: 3.5rem;
      margin-right: 0.5rem;
      display: inline-block;
      position: relative;
      .navBox-li-line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: #08568d;
      }
    }
    .li-activate {
      color: #08568d;
    }
    
  }
   // 隐藏滚动条
  .ul::-webkit-scrollbar {
    display: none;
  }
}
</style>